import type { SketchDefinition, SketchModelId } from '../types/sketch.types';
import type { Element } from '../types/enums';
import { EMOTION_NAMES } from './emotions.config';

/**
 * Registry of "croquis" (dream drawings). Each croquis confers one defensive
 * emotion-type; resistances/weaknesses derive from the fixed effectiveness
 * chart (cf. data/emotions.config.ts). Names are placeholders until the story
 * locks them in.
 *
 * Sketches are drops only — no forge, no tier system.
 */

function croquis(id: SketchModelId, emotion: Element): SketchDefinition {
  return {
    id,
    name: `Croquis : ${EMOTION_NAMES[emotion]}`,
    icon: id,
    emotion,
    sellValue: 20,
  };
}

export const SKETCH_REGISTRY: Record<SketchModelId, SketchDefinition> = {
  'sketch-joy': croquis('sketch-joy', 'joy'),
  'sketch-sadness': croquis('sketch-sadness', 'sadness'),
  'sketch-anger': croquis('sketch-anger', 'anger'),
  'sketch-fear': croquis('sketch-fear', 'fear'),
  'sketch-surprise': croquis('sketch-surprise', 'surprise'),
  'sketch-disgust': croquis('sketch-disgust', 'disgust'),
};
